export default __webpack_public_path__ + "static/media/44-min.afa3fc81.jpg";